/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import { Author } from '../types';
import { CDN_URLS } from '../config';

export const authors: Author[] = [
  {
    id: 'elara-vance',
    nameKey: 'author_elara_vance_name',
    bioKey: 'author_elara_vance_bio',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces`,
  },
  {
    id: 'julian-sinclair',
    nameKey: 'author_julian_sinclair_name',
    bioKey: 'author_julian_sinclair_bio',
    avatarUrl: `${CDN_URLS.UNSPLASH}photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=faces`,
  },
  /* {
     id: 'heidi-steiner',
     nameKey: 'author_heidi_steiner_name',
     bioKey: 'author_heidi_steiner_bio',
     avatarUrl: `${CDN_URLS.UNSPLASH}photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces`,
   },
   {
     id: 'lukas-weber',
     nameKey: 'author_lukas_weber_name',
     bioKey: 'author_lukas_weber_bio',
     avatarUrl: `${CDN_URLS.UNSPLASH}photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=faces`,
   }
     */
];